import React, { Component } from 'react';
import ComponentWrapper from './ComponentWrapper';
import mapError from './mapError';

export default class StaticField extends Component {
  render() {
    return (
      <ComponentWrapper
        {...this.props}
        mapProps={mapError}
        render={(props) => <span>{props.value}</span>}
      />
    );
  }
}
